import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import notify from 'Common/utils/notify';
import { toast } from 'react-toastify';
import deleteGroupInstructionAssignment from 'Education/api/instruction-assignment/group/deleteGroupInstructionAssignment';
import axios from 'axios';
import Modal from 'Common/components/Modals/Modal';
import Button from 'Common/components/Button';
import ModalTitle from 'Common/components/Modals/ModalTitle';

const GroupInstructionAssignmentDeleteModal = ({
    instructionAssignment,
    onCancel,
    onSuccess,
}) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const source = useMemo(() => axios.CancelToken.source(), []);

    useEffect(
        () => () => {
            source.cancel();
        },
        [source],
    );

    const handleConfirm = async () => {
        try {
            setIsDeleting(true);

            await deleteGroupInstructionAssignment(
                instructionAssignment.id,
                source.token,
            );

            onSuccess();

            setIsDeleting(false);

            notify('Der Präsenzunterweisung wurde erfolgreich gelöscht', {
                type: toast.TYPE.SUCCESS,
            });
        } catch (error) {
            if (!axios.isCancel(error)) {
                setIsDeleting(false);

                notify('Der Präsenzunterweisung konnte nicht gelöscht werden', {
                    type: toast.TYPE.ERROR,
                });
            }
        }
    };

    return (
        <Modal
            isOpen={instructionAssignment !== null}
            onRequestClose={isDeleting ? undefined : onCancel}
            buttons={
                <>
                    <Button
                        text
                        dark
                        type="button"
                        onClick={onCancel}
                        disabled={isDeleting}
                    >
                        Abbrechen
                    </Button>
                    <Button
                        type="button"
                        isLoading={isDeleting}
                        onClick={handleConfirm}
                        disabled={isDeleting}
                    >
                        Löschen
                    </Button>
                </>
            }
        >
            <ModalTitle>
                Wollen Sie der Präsenzunterweisung {instructionAssignment?.name}{' '}
                wirklich Löschen?
            </ModalTitle>
        </Modal>
    );
};

GroupInstructionAssignmentDeleteModal.defaultProps = {
    instructionAssignment: null,
};

GroupInstructionAssignmentDeleteModal.propTypes = {
    instructionAssignment: PropTypes.object,
    onCancel: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
};

export default GroupInstructionAssignmentDeleteModal;
